import React from "react";

const Forgot = () => {
  return <h1>Ini Halaman Forgot</h1>;
};

export default Forgot;
